import React, { useState } from 'react'
import {
  FormField,
  FormItem,
  FormMessage,
  Form,
  FormLabel,
  FormControl,
  FormDescription
} from '../../components/ui/form'
import { Card } from '../../components/ui/card'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  changePasswordSchema,
  verifyOTPSchema,
  resetPasswordSchema
} from './validators'
import { Input } from '../../components/ui/input'
import { Button } from '../../components/ui/button'
import { ClipLoader } from 'react-spinners'
import img from '../../pics/landImg.jpeg'
import { useCreateNewPassword, useVerifyOtp } from '../../hooks/auth'
import { useToast } from '../../components/ui/use-toast'
import { useNavigate } from 'react-router-dom'
import { useResetPassword } from '../../migration-api/api-hooks/auth'

const ResetPassword = () => {
  const { toast } = useToast()

  const navigate = useNavigate()
  const { resetPassword, isLoading } = useResetPassword({
    onSuccess: () => {
      toast({
        variant: 'success',
        title: 'Success',
        description: `${'Password changed successfully, please login'}`
      })

        setTimeout(() => {
          navigate('/')
        }, 3000)
    },
    onError: error => {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: `${error?.response?.data?.message}`
      })
    }
  })

  const form = useForm({
    resolver: zodResolver(resetPasswordSchema),
    defaultValues: {
      email: '',
      password: '',
      otp: ''
    }
  })

  function onSubmit (values) {
    resetPassword(values)
  }

  return (
    <section className='w-full h-full'>
      <div className=' pl-24  pt-10'>
        <img src='/sproxillogo.png' alt='' className='w-[120px]' />
      </div>

      <div className='flex flex-col'>
        <div className='w-full h-[80vh] flex flex-col gap-[10px] justify-center items-center'>
          <Card className=' h-[fit-content] w-[350px] p-[20px] min-w-[230px]'>
            <h4 className=' text-xs'>Enter your email and OTP below</h4>
            <br />
            <Form {...form}>
              <form
                onSubmit={form.handleSubmit(onSubmit)}
                className='space-y-8'
              >
                <FormField
                  control={form.control}
                  name='email'
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>Email</FormLabel>
                      <FormControl>
                        <Input placeholder='johndoe@gmail.com' {...field} />
                      </FormControl>
                      <FormDescription>
                        This is your registered email.
                      </FormDescription>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name='otp'
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>OTP</FormLabel>
                      <FormControl>
                        <Input placeholder='1111' {...field} />
                      </FormControl>
                      <FormDescription>
                        Enter the otp sent to your email.
                      </FormDescription>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <FormField
                  control={form.control}
                  name='password'
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>New Password</FormLabel>
                      <FormControl>
                        <Input
                          placeholder='Enter new password'
                          isPassword
                          type="password"
                          {...field}
                        />
                      </FormControl>
                      <FormDescription>
                        Enter the otp sent to your email.
                      </FormDescription>
                      <FormMessage />
                    </FormItem>
                  )}
                />

                <Button type='submit' variant='' disabled={isLoading}>
                  {isLoading ? (
                    <span className='mx-[20px]'>
                      <ClipLoader color='primary' size={20} />
                    </span>
                  ) : (
                    <span> Reset</span>
                  )}
                </Button>
              </form>
            </Form>
          </Card>
        </div>
      </div>
    </section>
  )
}

export default ResetPassword
